<template>
    <div class="dashboard">
        <navbar></navbar>
        <section class="is-medium">
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="tile is-ancestor user-tile">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                                <p class="title">User Information</p>
                                <table>
                                    <tr>
                                        <th>Name:</th>
                                        <td>{{name}}</td>
                                    </tr>
                                    <tr>
                                        <th>Email:</th>
                                        <td>{{email}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="tile is-ancestor user-tile">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                                <p class="title">Change Password</p>
                                <form class="card-content" @submit.prevent="changePassword">
                                    <p class="control">
                                        <input class="input" type="password" v-model="password" placeholder="Current Password" required>
                                    </p>
                                    <p class="control">
                                        <input class="input" type="password" v-model="password_new" placeholder="New Password" required>
                                    </p>
                                    <p class="control">
                                        <input class="input" type="password" v-model="password_new_confirmation" placeholder="Repeat New Password" required>
                                    </p>
                                    <p class="control">
                                        <button class="button is-primary is-medium is-fullwidth">Change Password</button>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar.vue";
    export default {
        name: "Profile",
        components: {Navbar},
        computed: {
            name () {
                return this.$store.state.user.name
            },
            email () {
                return this.$store.state.user.email
            }

        },

        methods: {
            changePassword() {
                let password = this.password
                let password_new = this.password_new
                let password_new_confirmation = this.password_new_confirmation
                this.$store.dispatch('changePassword', { password, password_new,password_new_confirmation })
                    .then(() => this.$router.push('/dashboard'))
                    .catch(err => console.log(err))
            }
        }
    }
</script>

<style scoped>
    .user-tile {
        max-width: 600px;
    }

    table, th {
        padding-right: 15px;
        padding-left: 15px;
    }

    .card {
        border-radius: 10px;
    }

    .login-title {
        color: #0f81cc;
        font-size: 1.5rem;
    }

    .card-content p {
        margin: 10px;
    }
    .card-content img {
        max-height: 1.75rem;
    }
</style>